<div class="activation-link-addon-selector">
  <div class="activation-link-addon-selector__typeahead" *ngIf="selectableAddons.length > 0">
    <div ngbDropdown class=" vox-input-group vox-input-group_dense vox-dropdown-input dropdown" [autoClose]="'outside'">
      <input
        class="vox-text-field"
        type="text"
        [placeholder]="'sales.activation-link.addon-card-selector.placeholder' | translate"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
        (focus)="onInputFocus()"
        ngbDropdownToggle
        [disabled]="disabled"
        autocomplete="off"
      />
      <div class="activation-link-addon-selector__dropdown-menu" ngbDropdownMenu>
        <button
          *ngFor="let addon of filteredAddons"
          ngbDropdownItem
          class="dropdown__item"
          type="button"
          (click)="selectAddon(addon)">
          {{ addon.name }}
        </button>
        <div *ngIf="filteredAddons.length === 0" class="dropdown__no-results">
          <span translate>sales.activation-link.addon-card-selector.no-results</span>
        </div>
      </div>
    </div>
  </div>

  <div class="activation-link-addon-selector__list">
    <div *ngFor="let addonControl of addonsFormArray.controls; let i = index; trackBy: trackByIndex" class="activation-link-addon-selector__item">
      <gdp-activation-link-addon-card
        [formControl]="addonControl"
        [name]="addonControl.value.name"
        [subtitle]="addonControl.value.id"
        [canRemove]="true"
        [min]="addonControl.value.min"
        [max]="addonControl.value.max"
        (remove)="removeAddon(i)">
      </gdp-activation-link-addon-card>
    </div>
  </div>
</div>
